import React from 'react';
import { Modal } from 'react-bootstrap';

const ImageModal = ({ show, onHide, imageUrl, title }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      contentClassName="bg-transparent border-0"
      backdropClassName="opacity-75"
    >
      <Modal.Header 
        closeButton 
        closeVariant="white" 
        className="border-0 pb-0"
        style={{ position: 'absolute', right: '10px', top: '10px', zIndex: 1051 }}
      />
      <Modal.Body className="p-0 d-flex flex-column align-items-center">
        <img
          src={imageUrl}
          alt={title}
          className="img-fluid rounded shadow-lg"
          style={{ 
            maxHeight: '85vh', 
            objectFit: 'contain',
            backgroundColor: '#fff' 
          }}
        />
        {title && (
          <div className="bg-dark text-white p-2 mt-2 rounded-pill px-4 opacity-75 small">
            {title}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ImageModal;